import { render, staticRenderFns } from "./DeliveryMethodInstanceListItem.vue?vue&type=template&id=3e73040d"
import script from "./DeliveryMethodInstanceListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodInstanceListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports